import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { StatusBar } from '../../../lib/components';

type Props = {
  title: string;
  icon: JSX.Element;
  percent: number;
};

export const BenefitSliderListItem: FC<Props> = ({ title, icon, percent }) => {
  return (
    <Box
      sx={{
        marginTop: '1.5rem',
        display: 'flex',
        gap: '0.75rem',
        '&:first-of-type': {
          marginTop: 0
        }
      }}
    >
      {icon}

      <Box margin="auto 0" flexGrow={1}>
        <Typography variant="body1" lineHeight="1.25rem" marginBottom="0.5rem">
          {title}
        </Typography>
        <Box display="flex" gap="0.75rem" alignItems="center">
          <StatusBar
            sx={{ flexGrow: 1 }}
            value={percent}
            displayMode="none"
            openBackgroundColor="grey.50"
          />
          <Typography
            width="2.25rem"
            color="grey.900"
            component="span"
            variant="caption"
            lineHeight="0.75rem"
            textAlign="end"
          >
            {`${percent} %`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
